"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var ScheduleResource = /** @class */ (function (_super) {
    tslib_1.__extends(ScheduleResource, _super);
    function ScheduleResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ScheduleResource.endpoint = '/schedules';
    ScheduleResource.MODEL_NAME = 'schedule';
    return ScheduleResource;
}(base_1.default));
exports.default = ScheduleResource;
//# sourceMappingURL=schedule.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/schedule.js
// module id = TB+7
// module chunks = 0